import { render } from "./vdercontractlistadd.vue?vue&type=template&id=1cf2b56a&scoped=true"
import script from "./vdercontractlistadd.vue?vue&type=script&lang=js"
export * from "./vdercontractlistadd.vue?vue&type=script&lang=js"

import "./vdercontractlistadd.vue?vue&type=style&index=0&id=1cf2b56a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf2b56a"]])

export default __exports__